import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthServiceService } from './services/auth-service.service';
import { Credentials } from '../../../entities/Credentials';
import { User } from '../../../entities/User';
import { ProductService } from 'src/app/shared/services/product.service';
import { ToastrService } from 'ngx-toastr';
import { RegistroUsuarioServiceService } from '../registro-afiliado/services/registro-usuario-service.service';
import { GoogleAnalyticsService } from '../../../shared/services/google-analytics.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  public credentials: Credentials;
  public idUsuario;
  public rutaFinal: string;
  public correoVerificado: boolean = false;
  public modalCodigo: boolean = true;


  constructor(private router: Router,
    private auth: AuthServiceService,
    private fb: FormBuilder,
    private analytics: GoogleAnalyticsService,
    private prodService: ProductService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private toastr:ToastrService,
    private service: RegistroUsuarioServiceService
) { }

public hide: boolean = true;
  
    ngOnInit() {
      this.initForm();
      this.route.paramMap.subscribe(params => {
        this.rutaFinal = params.get('id');
        if(params.get('id')=== 'validacion') {
          this.correoVerificado = true;
        } else {
          this.correoVerificado = false;
        }
      });
      this.route.params.subscribe(
        (params) => {
          this.idUsuario = params['idUsuario'];
          if (this.idUsuario != null){
            this.activarUsuario(this.idUsuario);
          }
        }
      );
      this.modalCodigo = this.service.modalCodigo;
      this.service.closeModal$.subscribe(closeModal => {
        this.modalCodigo = closeModal;
      });
    }
  
    initForm(){
      this.loginForm = this.fb.group({
        username:[],
        password:[]
      })
    }

    onSubmit() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // Para un desplazamiento suave
      });
      // this.loading = true;
      this.credentials = this.loginForm.value;
      this.auth.authenticate(this.credentials).subscribe(
        (result: User) => { 
          if(this.auth.statusAuth == 200) {            
            this.analytics.sendEvent('login', {
              idEvento: 1,
              method: 'email', // Puedes cambiarlo a 'google', 'facebook', etc., según el método de autenticación usado
              userName: this.credentials.username // Si tienes el ID del usuario autenticado
            });
            if(result.cartItems !== null) {
              if(result.cartItems.length > 0) {
                result.cartItems.forEach((prod) => {
                  this.prodService.addToCart(prod)              
                })
              }
            }
            this.auth.setData(result);
            if(this.rutaFinal === 'inicio') {
              this.router.navigate(['']);
            }
            if(this.rutaFinal === 'checkout') {
              this.router.navigate(['/shop/checkout']);
            }
            if(this.rutaFinal === 'validacion') {
              this.router.navigate(['/home/whatch']);
            }                        
          } else if(this.auth.statusAuth == 202) {
            this.modalCodigo = true;
            this.service.obtenerRutaRedirigir('/home/whatch');
            this.service.obtenerTextoModalCodigoLogin(result.nombre)
            this.service.obtenerIdUserRegistro(result.idUsuario)
            this.service.reenviarCodigo(this.loginForm.controls.username.value);
            // window.location.href = result.urlFactura;
          }
        },
        err=>{
          this.analytics.sendEvent('error_login', {
            idEvento: 10,
            method: 'email',  // Método de autenticación usado
            reason: 'Credenciales incorrectas', // Mensaje del error
            userName: this.credentials.username // Si tienes el ID del usuario autenticado
          });
          this.toastr.error('Usuario o contraseña incorrectos')
        })
    }
    
    registrarUsuario(){
      this.router.navigateByUrl('/pages/registro-usuario')
    }

    activarUsuario(idUsuario){
      this.auth.activarUsuario(idUsuario).subscribe(result=>{
          this.toastr.success('Usuario Activado');
      })
    }
    
    togglePassword() {
      this.hide = !this.hide;
    }

}
